<!-- 产品销售图片链接列表：模块头+图片+标题+链接 -->
<template>
<div class="info-block">
  <router-link :to="{path: '/cyfw/nzDetail/machinery/'+info.id}" v-bind:style="{backgroundImage:'url('+info.cover_img+')'}">
    <div class="div-1">
      <div class="div-1-1">热卖</div>
    </div>
    <div class="div-2">
      <table border="0" cellpadding="2" cellspacing="0" >
        <tr>
          <td colspan="2" class="price">{{info.price}}</td>
        </tr>
        <tr>
          <td colspan="2" class="title">{{info.name}}</td>
        </tr>
        <tr>
          <td colspan="2" class="label">{{info.enterprise_intro}}</td>
        </tr>
        <tr>
          <td><span class="evaluate">0</span>条评价</td>
          <td class="total">0人已购买</td>
        </tr>
        <tr>
          <td colspan="2">{{info.enterprise_name}}</td>
        </tr>
      </table>
    </div>
  </router-link>
</div>
</template>

<script>
export default {
  name: 'InfoBlock18',
  props: {
    info: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {

    }
  },
  created:function(){

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.info-block a{
  display: block;
  height:300px;
  position:relative;
  box-sizing: border-box;
  padding:0px;
  margin:4px;
  background-color: #fff;
  border:1px solid #eee;
  background-size: auto 180px;
  background-repeat: no-repeat;
  background-position: center 0;
  //box-shadow: #bbb 0px 0px 10px;
}

.info-block a:hover{
  border:1px solid var(--color6);
  //box-shadow: var(--color6) 0px 0px 5px;
}
.div-1{
  position:relative;
  height:60%;
  //background:green;
}

.div-1-1{
  position: absolute;
  left: -1px;
  top: -1px;
  padding:2px 4px 2px 4px;
  color:#fff;
  background:var(--color6);
  border-radius:0px 0px 8px;
}

.div-2{
  position:relative;
  height:40%;
  //background:blue;
}

.div-2 table{
  width:100%;
  height:100%;
  padding:0px 5px 0px 5px;
  font-size:12px;
  text-align:left;
  color:#aaa;
}

.price{
  font-size:16px;
  font-weight:600;
  color:red;
}
.price{
  font-size:16px;
  font-weight:600;
  color:red;
}

.price:before{
    content: "\00A5";
    font-size: 12px;
    color: #red;

}

.title{
  font-size:12px;
  font-weight:800;
  line-height:18px;
  color:#000;
}

.label{
  font-size:12px;
  color: var(--color6);
  line-height:12px;
}

.evaluate{
  font-size:12px;
  color: green;
  font-weight:600;
}

</style>



// WEBPACK FOOTER //
// src/components/block/InfoBlock18.vue